import { useParseTranslation } from '@/hooks/useParseTranslation';
import { CheckOutlined, UpCircleFilled } from '@ant-design/icons';
import { Collapse, Divider } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo, useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.less';
const { Panel } = Collapse;

const BookmarkItem = ({
  title,
  data,
  bookmarkId,
  field,
  divider,
  translationNs,
  selected,
  onSelectedChange,
}) => {
  const { t } = useTranslation('templates');

  const parseTranslation = useParseTranslation(translationNs);

  const translatedItemTitle = useCallback((item) => (
    parseTranslation(item, field)?.capitalize()
  ), [parseTranslation, field]);

  const handleClick = useCallback((item) => () => {
    onSelectedChange?.(item, bookmarkId);
  }, [onSelectedChange, bookmarkId]);

  if (data?.length) {

    return (<>
      { divider && <Divider /> }
      <Collapse
        defaultActiveKey={ ['1'] }
        ghost
        expandIcon={ ({ isActive }) => <UpCircleFilled className="text-lg" rotate={ isActive ? 180 : 0 } /> }
      >
        <Panel header={ <span className="font-bold">{ t(title) }</span> } key="1">
          {
            data?.map((item, idx) => {
              const isActive = (selected?._id === item?._id);
              return (
                <li
                  key={ idx }
                  className={ classNames(styles.bookmarksItem, isActive ? styles.activeSection : '') }
                  onClick={ handleClick(item) }
                >
                  { isActive
                    ? <CheckOutlined style={ { fontSize: '0.75rem' } } />
                    : <div className={ styles.dot } />
                  }
                  <span className="ml-1 w-full">{ translatedItemTitle(item) }</span>
                </li>
              );
            }
            ) }
        </Panel>
      </Collapse>
    </>);
  }

  return (<></>);
};

BookmarkItem.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  bookmarkId: PropTypes.string,
  field: PropTypes.string,
  divider: PropTypes.bool,
  translationNs: PropTypes.string,
  selected: PropTypes.object,
  onSelectedChange: PropTypes.func
};

BookmarkItem.defaultProps = {
  field: 'title',
  translationNs: 'templates'
};

export default memo(BookmarkItem);
